/* eslint-disable no-unused-vars */
import axios from "axios";
import moment from "moment";
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/routes`;

String.prototype.allReplace = function(obj) {
  var retStr = this;
  for (var x in obj) {
    retStr = retStr.replace(new RegExp(x, "g"), obj[x]);
  }
  return retStr;
};

let messageConfig = {
  "<p>": "&lt;span&gt;",
  "</p>": "&lt;/span&gt;",
  'class="mention"':
    'class="mention" style="font-weight: bold; display: inline;"',
  "<": "&lt;",
  ">": "&gt;",
  "a href=": 'a target="_blank" href=',
  // '&lt;': '<',
  // '&gt;': '>',
};

let messageConfigDecrypt = {
  "&lt;": "<",
  "&gt;": ">",
};

const state = {
  route_comments: [],
  opened_comments: [],
};

const getters = {
  getRouteComments: (state) => state.route_comments,
  getOpenedComments: (state) => state.opened_comments,
};

const actions = {
  async openRouteComments({ commit }, body) {
    let willFetch = true;

    if (body.type == "mainroute") {
      if (state.route_comments.length > 0) {
        if (state.route_comments[0].route_id == body.route_id)
          willFetch = false;
      }
    }

    if (willFetch == false) return true;

    try {
      let routeURL =
        body.type != "mainroute"
          ? `${url}/assignedRoute/comment/${body.route_id}/${body.assigned_route_id}`
          : `${url}/comment/${body.route_id}`;

      if (body.page) routeURL += `?page=${body.page}&limit=5`;

      const authToken = localStorage.getItem("access_token");
      let response = await axios.get(routeURL, {
        headers: {
          "x-drmms-token": authToken,
        },
      });

      let data = Object.assign(response.data, {
        date: moment(response.data.createdAt).format("LLL"),
        route_id:
          body.type == "mainroute" ? body.route_id : body.selected_route_id,
        type: body.type,
      });

      let rows = data.rows.map((row) => ({
        ...row,
        msg: row.message.allReplace(messageConfigDecrypt),
        date: moment(row.createdAt).format("LLL"),
      }));

      data.rows = rows;

      body.data = data;

      commit("addOpenedComments", body);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async saveNewComment({ commit }, body) {
    let routeURL = "";

    let message = body.message;

    message = message.allReplace(messageConfig);

    let data = {
      message: message,
      user_tag_ids: body.user_tag_ids,
    };

    if (body.type != "mainroute") {
      routeURL = `${url}/assignedRoute/comment/${body.route_id}/${body.assigned_route_id}`;
      data.selected_route_id = body.selected_route_id;
    } else {
      routeURL = `${url}/comment/${body.route_id}`;
    }

    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios.post(routeURL, data, {
        headers: {
          "x-drmms-token": authToken,
        },
      });

      let newComment = Object.assign(response.data, {
        date: moment(response.data.createdAt).format("LLL"),
        msg: message.allReplace(messageConfigDecrypt),
        route_id:
          body.type == "mainroute" ? body.route_id : body.selected_route_id,
      });

      body.newComment = newComment;

      commit("newComment", body);
      return body;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async fetchMoreComments({ commit }, body) {
    let routeURL =
      body.type != "mainroute"
        ? `${url}/assignedRoute/comment/${body.route_id}/${body.assigned_route_id}`
        : `${url}/comment/${body.route_id}`;

    if (body.page) routeURL += `?page=${body.page}&limit=5`;

    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios.get(routeURL, {
        headers: {
          "x-drmms-token": authToken,
        },
      });

      let data = Object.assign(response.data, {
        date: moment(response.data.createdAt).format("LLL"),
      });

      let rows = data.rows.map((row) => ({
        ...row,
        msg: row.message.allReplace(messageConfigDecrypt),
        date: moment(row.createdAt).format("LLL"),
      }));

      data.rows = rows;

      body.data = data;
      commit("addMoreComments", body);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
};

const mutations = {
  newComment: (state, comment) => {
    if (comment.type != "mainroute") {
      const index = state.opened_comments.findIndex(
        (opened_comment) =>
          opened_comment.route_id == comment.assigned_route_id &&
          opened_comment.assigned_route_id == comment.selected_route_id &&
          opened_comment.type == comment.type
      );


      if (index !== -1) {
        const oldComments = state.opened_comments[index].comments.rows;

        oldComments.unshift(comment.newComment);

        let updatedCommentData = state.opened_comments[index].comments;
        updatedCommentData.rows = oldComments;

        const updatedData = {
          route_id: comment.route_id,
          assigned_route_id: comment.selected_route_id,
          type: comment.type,
          comments: updatedCommentData,
        };
        state.opened_comments.splice(index, 1, updatedData);
      }
    } else {
      let oldComments = state.route_comments[0].rows;
      oldComments.unshift(comment.newComment);

      state.route_comments[0].rows = oldComments;
    }
  },
  addOpenedComments: (state, comment) => {
    let checkExistence = false;

    if (comment.type != "mainroute") {
      state.opened_comments.forEach((element) => {
        if (
          element.route_id == comment.route_id &&
          element.type == comment.type &&
          element.assigned_route_id == comment.assigned_route_id
        )
          checkExistence = true;
      });

      if (!checkExistence) {
        state.opened_comments.push({
          route_id: comment.route_id,
          assigned_route_id: comment.assigned_route_id,
          type: comment.type,
          comments: comment.data,
        });
      }
    } else {
      state.route_comments = [];
      state.route_comments.push(comment.data);
    }
  },
  addMoreComments: (state, comment) => {
    if (comment.type != "mainroute") {
      const index = state.opened_comments.findIndex(
        (opened_comment) =>
          opened_comment.route_id == comment.route_id &&
          opened_comment.assigned_route_id == comment.assigned_route_id &&
          opened_comment.type == comment.type
      );

      if (index !== -1) {
        const oldComments = state.opened_comments[index].comments.rows;
        let newComments = comment.data.rows;
        let updatedComments = oldComments.concat(newComments);

        if (comment.page == 1) comment.data.rows = newComments;
        else comment.data.rows = updatedComments;

        const updatedData = {
          route_id: comment.route_id,
          assigned_route_id: comment.assigned_route_id,
          type: comment.type,
          comments: comment.data,
        };
        state.opened_comments.splice(index, 1, updatedData);
      }
    } else {
      try {
        const oldComments = state.route_comments[0].rows;
        let newComments = comment.data.rows;

        let updatedComments = oldComments.concat(newComments);

        if (comment.page == 1) comment.data.rows = newComments;
        else comment.data.rows = updatedComments;
        // comment.data.rows = updatedComments;

        state.route_comments[0].rows = comment.data.rows;
      } catch (err) {
        console.log(err);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
